<template>
    <el-dialog class="user_video_record" title="视频记录" :close-on-click-modal=false :visible.sync="dialogVisible" width="600px">
        <!-- 视频记录 -->
        <div class="va">
            <el-table
                :data="vadeorecord"
                style="width: 100%">
                <el-table-column
                    prop="joinUser"
                    label="参会人">
                </el-table-column>
                <el-table-column
                    width="120"
                    label="上传时间">
                    <template slot-scope="scope">
                        {{Boolean(vadeorecord[scope.$index].download)?dateFormat(vadeorecord[scope.$index].uploadTime,'yyyy-MM-dd'):''}}
                    </template>
                </el-table-column>
                <el-table-column
                    width="220"
                    label="播放、下载">
                    <template slot-scope="scope">
                        <a v-if="vadeorecord[scope.$index].download"
                            :href="vadeorecord[scope.$index].download" target="_blank" style="color: #2279db;text-decoration: underline">点击播放 或 右击链接另存为</a>
                        <span v-else>暂无记录</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- end -->
    </el-dialog>
</template>
<script>
/**
 * 使用
 * 父组件 引入 <video-record ref="comVideoRecord"></video-record>
 * 相应的点击事件
 * openvideodialog(type,meetingid) {
        let title
        if(type == 'va') {
            title = '视频记录'
        }else if(type == 'vb'){
            title = '调解笔录'
        }
        this.$refs.comVideoRecord.openDialog(type,title,meetingid,this.caseid)
    }
 **/
import {getVideoListDetail} from '@/api/meeting'
import {dateformat} from '@/utils/utils.js'
export default {
    data() {
        return {
            BtnLoading:false,
            dialogVisible: false,
            vadeorecord: [],
            documentId:'',
        }
    },
    props:['comuserid','currentype'],
    methods: {
        getVideoRecordList(id) { // 视频记录
            getVideoListDetail({
                "meetingId": id
            }).then((res) => {
                this.vadeorecord = res.data.data
            },(error)=>{
                console.log(error)
            })
        },
        openDialog(meetingid) {
            this.dialogVisible = true
            this.getVideoRecordList(meetingid)
           
        },
        dateFormat(data,type) {
            if(data) {
                return dateformat(new Date(data),type)
            }
        },
        watchVideo(url) {
            window.open(url)
        },
        
        
        
        
        browserType() {
            var userAgent = navigator.userAgent.toLowerCase();
            // Figure out what browser is being used
            var testCenter = {
                ie:function isIE() { //ie?
                    if (!!window.ActiveXObject || "ActiveXObject" in window)
                        return true;
                    else
                        return false;
                },
                edge : ()=>{ return /dge/.test(userAgent) },
                chrome:()=>{ return /chrome/.test(userAgent)},
                safari: ()=>{  return /safari/.test(userAgent)&&!(/chrome/.test(userAgent))},
                opera: ()=>{  return  /opera/.test(userAgent) } ,
                msie: ()=>{  return /msie/.test(userAgent) && !/opera/.test(userAgent) },
                mozilla: ()=>{  return /mozilla/.test(userAgent) && !/(compatible|webkit)/.test(userAgent) }
            };
            var browserObj = {};
            for(var k in testCenter){
                var result = testCenter[k]();
                var version = (userAgent.match(/.+(?:rv|it|ra|ie)[\/: ]([\d.]+)/) || [])[1];
                if(result){
                    browserObj.browser = k;
                    browserObj.version = version;
                    return browserObj;
                }
            }
        },
        downVideo(options) {
            let that = this;
            let fileName = options.url.substring(options.url.lastIndexOf('/')+1);
            let url = options.url;
            let xhr = new XMLHttpRequest();        //发起请求
            xhr.open('get', url);
            xhr.responseType = 'blob';        //规定响应为流文件
            xhr.send();
            xhr.onreadystatechange = function(){
                if (this.readyState == 4){
                    if (this.status == '401' || this.status == '402') {
                                     //在这里可以进行一些请求失败的处理
                    }
                    else if(this.status == 200) {
                        let currentBrowserType = that.browserType();  //判断浏览器类型  见上述browserType函数；
                        if(currentBrowserType.browser==='ie'&&(currentBrowserType.version == "10.0" || currentBrowserType.version == "11.0")){   //如果IE创建iframe对象来下载

                            let href = window.URL.createObjectURL(this.response);
                            let elemIF = document.createElement("iframe");
                            elemIF.src = "http://" + location.host + '/crowd-web/file/downloadFile';
                            elemIF.style.display = "none";
                            document.body.appendChild(elemIF);
                        }else if( currentBrowserType.browser==='edge'){ //如果edge使用h5的a标签的下载功能实现
                            if (this.getResponseHeader("content-disposition")) {
                                fileName = decodeURI(this.getResponseHeader("content-disposition").replace("attachment;filename=", ""));
                            }
                            let downloadUrl = "http://" + location.host + '/crowd-web/file/downloadFile';
                            let a = document.createElement("a");
                                a.href = downloadUrl;
                                a.download = fileName;
                                document.body.appendChild(a);
                                a.click();
                                window.URL.revokeObjectURL(downloadUrl);
                        } else {  //其他现代浏览器采用H5的a标签新特性实现
                            let downloadUrl = window.URL.createObjectURL(this.response);
                            if (this.getResponseHeader("content-disposition")) {
                                fileName = decodeURI(this.getResponseHeader("content-disposition").replace("attachment;filename=", ""));
                            }
                            let a = document.createElement("a");
                                a.href = downloadUrl;
                                a.download = fileName;
                                document.body.appendChild(a);
                                a.click();
                            window.URL.revokeObjectURL(downloadUrl); //告诉浏览器可以释放该路径
                        }
                    }
                }
            };
        },
    }
}
</script>
<style lang="scss">

.user_video_record {
    .md-head {
        height: 30px;
        margin-bottom: 12px;
        line-height: 30px;
        text-align: right;
        margin-top: 20px;
        > span {
            float: left;
            font-size: 14px;
            font-weight: bold;
        }
        .el-input {
            width: 150px;
        }
        .el-input--small .el-input__inner {
            height: 30px;
            line-height: 30px;
        }
    }
    .dialog-footer {
        padding-top: 10px;
    }
}
</style>

